// @ts-check
/**
 * Typed client for background file exports (backend api/exports).
 *
 * An export endpoint starts a job and returns it (202); the `exports` Vuex
 * module tracks it, toasts when it is ready, and lists it under Downloads in
 * the profile menu. Types come from the generated `schema.d.ts`.
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['ExportJob']} ExportJob */
/** @typedef {Schemas['ExportDownloadResponse']} ExportDownloadResponse */
/** @typedef {Schemas['DischargeWaterfallExportRequest']} DischargeWaterfallExportRequest */

/**
 * GET /api/exports/ -- the current user's exports in this tenant from the last 24h.
 * @returns {Promise<ExportJob[]>}
 */
export async function listExports() {
  const { data } = await axios.get('/api/exports/')
  return data
}

/**
 * GET /api/exports/{jobId}/download/ -- short-lived presigned URL for a finished export.
 * @param {string} jobId
 * @returns {Promise<ExportDownloadResponse>}
 */
export async function getExportDownload(jobId) {
  const { data } = await axios.get(`/api/exports/${jobId}/download/`)
  return data
}

/**
 * POST /api/care-management/discharge-waterfall/export/ -- start a Discharge Waterfall episodes export.
 * @param {DischargeWaterfallExportRequest} body
 * @returns {Promise<ExportJob>}
 */
export async function startDischargeWaterfallExport(body) {
  const { data } = await axios.post('/api/care-management/discharge-waterfall/export/', body)
  return data
}
